$('.acc-trigger').on('click', function () {
  $(this).next().stop().slideToggle();
  $(this).toggleClass('is-active');
  $(this).parent().toggleClass('on-view ');
});
$('.acc-trigger-bottom').on('click', function () {
  $(this).prev().stop().slideToggle();
  $(this).toggleClass('is-active');
  // テキストを切り替え
  if ($(this).hasClass('is-active')) {
    $(this).text('プロフィールを閉じる');
  } else {
    $(this).text('プロフィールを見る');
  }
});

